import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { InsideSection } from './components/InsideSection';
import { TransformationSection } from './components/TransformationSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-navy-900 font-sans" data-id="element-0" data-mp="2wjgrrkg09zhh">
      <Hero data-id="element-1" data-mp="2wip734ny5m5z" />
      <main data-id="element-2" data-mp="2wi5mthatqlos">
        <ProblemSection data-id="element-3" data-mp="28ufoscpxzgjl" />
        <SocialProofSection data-id="element-4" data-mp="28tmg367fagyt" />
        <InsideSection data-id="element-5" data-mp="28suw6sn6u7od" />
        <TransformationSection data-id="element-6" data-mp="28s2xva27hvue" />
        <SolutionSection data-id="element-7" data-mp="23vupqgmff2wq" />
        <FAQSection data-id="element-8" data-mp="23ujk0b9f7l2z" />
        <FinalCTASection data-id="element-9" data-mp="23v2sl1d6kx4c" />
      </main>
      <SiteFooter data-id="element-10" data-mp="3ik7eyd5x05p2" />
    </div>;
}